export const chartImageScaleFactor = 4;

export const defaultAreaId = 21;

export const exportButtons = [
  "downloadPNG",
  "downloadSVG",
  "separator",
  "downloadCSV",
  "downloadXLS"
];

export const methods = [
  "Sterilization",
  "Implant",
  "IUD",
  "Injectable",
  "Pill",
  "Condom",
  "Other"
];

export const reportingYear = 2018;
